import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_QIO_REP_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const invTotalRef = useRef<number>(0); // 기간 최종 재고수량 (footer 고정값)
  //#endregion

  //#region Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          // 재고수량(qt_inv)은 화면에서 계산하므로 footer 표시 대상으로 포함
          grid1: (rtn.grid.grid1 || []).map((col: any) =>
            col.cd_column === "qt_inv" ? { ...col, yn_sum: "Y" } : col
          ),
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region 푸터 재고수량 계산
  const setInvQty = (rows: any[]) => {
    let inv = 0;
    const rtn = (rows || []).map((row: any) => {
      inv += Number(row.qt_rcv || 0) - Number(row.qt_isu || 0);
      return { ...row, qt_inv: Number(inv.toFixed(6)) };
    });
    invTotalRef.current = Number(inv.toFixed(6)); // 기간 최종 재고수량 (footer 표시용)
    return rtn;
  };

  // 최종 재고수량(고정값)
  const onBeforeSetFooter = (footer: Record<string, any>) => ({
    ...footer,
    qt_inv: invTotalRef.current,
  });

  // 정렬/필터로 행 순서가 바뀌면 화면에 보이는 순서대로 재고수량을 다시 누적한다.
  const recalcInvQty = () => {
    const grid = gridRefs.current["grid1"]?.current;
    if (!grid) return;

    const rowCount = grid.getDisplayedRowCount();
    let inv = 0;
    for (let i = 0; i < rowCount; i++) {
      const node = grid.getRowNodeAtIndex(i);
      if (!node?.data) continue;

      inv += Number(node.data.qt_rcv || 0) - Number(node.data.qt_isu || 0);
      const qt_inv = Number(inv.toFixed(6));
      if (node.data.qt_inv !== qt_inv) {
        node.setData({ ...node.data, qt_inv });
      }
    }
  };

  //#endregion

  //#region onSearch
  const onSearch = async () => {
    try {
      const requiredValuesCheckSearch = searchRef.current.requiredValuesCheck();
      if (!requiredValuesCheckSearch) return false;

      const param = {
        id: "sn_mtl_qio_rep_001_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: setInvQty(data[0]),
      });
    } catch (error) {}
  };
  //#endregion

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnGrid
          ref={gridRefs.current["grid1"]}
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "multiple",
            isEditable: false,
          }}
          events={{
            onBeforeSetFooter: onBeforeSetFooter,
            onSortChanged: recalcInvQty,
            onFilterChanged: recalcInvQty,
          }}
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_MTL_QIO_REP_001;
